export let accessOptions = [
    { label: "Select Access", value: "" },
    { label: "No Access", value: "No Access" },
    { label: "SuperAdmin", value: "SuperAdmin" },
    { label: "Admin", value: "Admin" }
  ];
  
export const default_access = 
  [
    {
      "module": "Main Dashboard",
      "access": "No Access"
    },
    {
      "module": "Organization",
      "access": "No Access"
    },
    {
      "module": "Pricing",
      "access": "No Access"
    },
    {
      "module": "Users",
      "access": "No Access"
    },
  ]